export default "__VITE_ASSET__BRcatTf4__"